import { Typography } from '@mui/material';
import React from 'react';

const ContactFormResult = (): JSX.Element | null => (
  <>
    <Typography variant="h3">
      Thank you for reaching out to Pizza Hut, your feedback is on its way!
    </Typography>
    <br />
    <Typography gutterBottom>
      We strive to give you the best possible guest experience and value your input. We will respond to your feedback as quickly as possible.
    </Typography>
  </>
);

export default ContactFormResult;
